import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { endOfDay, startOfDay } from "date-fns";

import type { RootState } from "@/store";

export type DashboardReducerType = {
  activeTab: RangeType;
  dateStart: Date;
  dateStop: Date;
  team: null | TeamRefWithName;
};

type DateTabActionType = { tab: RangeType; start: Nullable<Date> | undefined; stop: Nullable<Date> | undefined };
type TeamTabActionType = Nullable<TeamRefWithName>;

const initialState: DashboardReducerType = {
  activeTab: "today",
  dateStart: startOfDay(new Date()),
  dateStop: endOfDay(new Date()),
  team: null,
};

const contactsSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setActiveTab(state, action: PayloadAction<DateTabActionType>) {
      state.activeTab = action.payload.tab;

      if (action.payload.start && action.payload.stop) {
        state.dateStart = action.payload.start;
        state.dateStop = action.payload.stop;
      }
    },
    setTeam(state, action: PayloadAction<TeamTabActionType>) {
      state.team = action.payload;
    },
  },
});

export const { setActiveTab, setTeam } = contactsSlice.actions;
export const dashboardSelector = (state: RootState) => state.dashboard;
export default contactsSlice.reducer;
